<template>
  <div class="section-abstract mb-1">

    <v-row class="ma-0" style="padding-left: 15px">
      <v-col>
        <div class="section-abstract-title">Coordonnées</div>
      </v-col>
    </v-row>
    <v-row class="ma-0 abstract-row" @click="openSection('SectionAdresseExtend', 'etablissement', false)">
      <v-col class="py-0">
        <div class="section-abstract-value">{{ adresse.adresse1 + ', ' + adresse.codePostal + ', ' + adresse.ville }}
          <v-icon class="pl-2" color="rgb(var(--v-theme-secondary60))" size="14"
                  @click.stop="copyText(adresse.adresse1 + ', ' + adresse.codePostal + ', ' + adresse.ville, 1 )">
            {{ copiedField === 1 ? 'fas fa-check' : 'fas fa-copy' }}
          </v-icon>
        </div>
        <div class="section-abstract-grid" style="display:grid; grid-template-columns: repeat(1, minmax(0, 1fr)); column-gap: 16px; row-gap: 0; align-items: start;">
        </div>
      </v-col>
      <v-col class="py-0" cols="1" style=" align-content: center; align-items: center">
        <v-icon class="arrow-icon" style="font-size: 12px; color: #25A3A7;">
          fas fa-chevron-right
        </v-icon>
      </v-col>
    </v-row>
    <v-row class="ma-0 abstract-row" @click="openSection('SectionEtablissementContactExtend', 'etablissement', false)">
      <v-col class="py-0">
        <div class="section-abstract-title">{{ !etablissement.mail && !etablissement.numero ? "Renseigner les contacts de l'établissement" : "" }}</div>

        <div class="section-abstract-grid" style="display:grid; grid-template-columns: repeat(1, minmax(0, 1fr)); column-gap: 16px; row-gap: 0; align-items: start;">
          <div v-if="etablissement.mail" class="section-abstract-cell" style="grid-row: 1 / span 1; grid-column: 1 / span 1;">
            <div class="section-abstract-value">{{ etablissement.mail }} <v-icon v-if="etablissement.mail" class="pl-2" color="rgb(var(--v-theme-secondary60))" size="14" @click.stop="copyText(etablissement.mail, 2)">  {{ copiedField === 2 ? 'fas fa-check' : 'fas fa-copy' }}</v-icon></div>
          </div>
          <div v-if="etablissement.numero" class="section-abstract-cell" style="grid-row: 2 / span 1; grid-column: 1 / span 1;">
            <div class="section-abstract-value">{{ etablissement.numero }} <v-icon v-if="etablissement.numero" class="pl-2" color="rgb(var(--v-theme-secondary60))" size="14" @click.stop="copyText(etablissement.numero, 3)">  {{ copiedField === 3 ? 'fas fa-check' : 'fas fa-copy' }}</v-icon></div>
          </div>
        </div>
      </v-col>
      <v-col class="py-0" cols="1" style=" align-content: center; align-items: center">
        <v-icon class="arrow-icon" style="font-size: 12px; color: #25A3A7;">
          fas fa-chevron-right
        </v-icon>
      </v-col>
    </v-row>
  </div>
</template>

<script lang="ts">
  import {defineComponent, type PropType} from "vue";
  import SectionEtablissementAdresseAbstract from '@/generated/sections/SectionEtablissementAdresseAbstract.vue';
  import type Adresse from "@/extend/classes/Adresse.ts";

  export default defineComponent({
    extends: SectionEtablissementAdresseAbstract,
    components: {},
    props: {
      adresse: {
        type: Object as PropType<Adresse>,
      },
    },
  })
</script>
